import * as actionTypes from '../actions/actionTypes';
import {
  updateObject
} from '../../shared/utility';

const initialState = {
  error: false,
  loading: false,
  loaded: false,
  propertyManager: {},
  tenantDetails: null,
  tenantStats:null,
  tenantDetailsLoading: false,
  tenantDetailsLoaded: false,
  tenantDetailsError: false,
  restoreServiceSuccess: false,
  restoreServiceError: false,
  filter:{},
};
const initPropertyManagerStart = (state, action) => {
  return updateObject(state, {
    error: false,
    loading: true,
    loaded: false,
    success: false
  });
};

const setPropertyManagerDetails = (state, action) => {
  // console.log(action, state)
  return updateObject(state, {
    propertyManager: action.propertyManager,
    loading: false,
    loaded: true,

  });
};

const setPropertyManagerFailed = (state, action) => {
  return updateObject(state, {
    loaded: true,
    loading: false,
    error: true
  });
};

const setPropertyManagerSuccess = (state, action) => {
  return updateObject(state, {
    loaded: true,
    loading: false,
    error: false,
  });
};

const initPropertyManagerTenantDetailsStart = (state, action) => {
  return updateObject(state, {
    tenantDetailsLoading: true,
    tenantDetailsLoaded: false,
    tenantDetailsError: false,
    filter:action.filter

  });
};

const setPropertyManagerTenantDetails = (state, action) => {
  return updateObject(state, {
    tenantStats: action.response.tenantStats.data,
    tenantDetails: action.response.tenantData.data || {
      "content": [],
    },
    tenantDetailsLoading: false,
    tenantDetailsLoaded: true,
  });
};

const setPropertyManagerTenantDetailsFailed = (state, action) => {
  return updateObject(state, {
    tenantDetailsLoaded: true,
    tenantDetailsLoading: false,
    tenantDetailsError: true
  });
};

const setPropertyManagerTenantDetailsSuccess = (state, action) => {
  return updateObject(state, {
    tenantDetailsLoading: false,
    tenantDetailsLoaded: true,
    tenantDetailsError: false
  });
};

const setRestoreServiceTenanantAccountSuccess = (state, action) => {
  return updateObject(state, {
    restoreServiceError: false,
    restoreServiceSuccess: true
  })
}

const setRestoreServiceTenanantAccountFailed = (state, action) => {
  return updateObject(state, {
    restoreServiceError: true,
    restoreServiceSuccess: false
  })
}
const resetPropertyManagerFlags = (state, action) => {
  return updateObject(state, {
    restoreServiceError: false,
    restoreServiceSuccess: false
  })
}


const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INIT_PROPERTY_MANAGER_START:
      return initPropertyManagerStart(state, action);
    case actionTypes.SET_PROPERTY_MANAGER_DETAILS:
      return setPropertyManagerDetails(state, action);
    case actionTypes.SET_PROPERTY_MANAGER_SUCCESS:
      return setPropertyManagerSuccess(state, action);
    case actionTypes.SET_PROPERTY_MANAGER_FAILED:
      return setPropertyManagerFailed(state, action);
    case actionTypes.SET_PROPERTY_MANAGER_TENANT_DETAILS:
      return setPropertyManagerTenantDetails(state, action);
    case actionTypes.INIT_PROPERTY_MANAGER_TENANT_DETAILS_START:
      return initPropertyManagerTenantDetailsStart(state, action)
    case actionTypes.SET_PROPERTY_MANAGER_TENANT_DETAILS_SUCCESS:
      return setPropertyManagerTenantDetailsSuccess(state, action);
    case actionTypes.SET_PROPERTY_MANAGER_TENANT_DETAILS_FAILED:
      return setPropertyManagerTenantDetailsFailed(state, action);
      case actionTypes.RESTORE_SERVICE_TENANT_ACCOUNT_SUCCESS:
        return setRestoreServiceTenanantAccountSuccess(state, action);
    case actionTypes.RESTORE_SERVICE_TENANT_ACCOUNT_FAILED:
        return setRestoreServiceTenanantAccountFailed(state, action);
    case actionTypes.RESET_PROPERTY_MANAGER_FLAGS:
        return resetPropertyManagerFlags(state, action);
    case actionTypes.CREATE_IOT_SSID_NETWORK:
        return updateObject(state , action);
    
      
  
    default:
      return state;
  }
};

export default reducer;
